module.exports = __webpack_public_path__ + "img/public/AdminIcons/uploadCSV.svg?d99ee5c1";